export default __webpack_public_path__ + "static/media/modal_logo_2.a27997ff.png";